import { IconButton, Tooltip } from "@mui/material";
import { observer } from "mobx-react";
import { FC } from "react";

import RefreshIcon from "../icons/RefreshIcon";
import { useTicketStore } from "../../hooks/useTicketStore";

export const TicketRefreshAction: FC = observer(() => {
  const { loadTickets, isLoading } = useTicketStore();

  return (
    <Tooltip arrow title="Refresh">
      <span>
        <IconButton
          aria-label="Refresh data"
          onClick={() => loadTickets()}
          disabled={isLoading}
          sx={(theme) => ({
            border: "1px solid",
            borderColor: "divider",
            borderRadius: "8px",
            background: "white",
            width: 36,
            height: 36,
            flexShrink: 0,
            color: theme.palette.text.secondary,
            "&:hover": {
              backgroundColor: theme.palette.action.hover,
            },
          })}
        >
          <RefreshIcon />
        </IconButton>
      </span>
    </Tooltip>
  );
});
